// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"237":"892a1494","312":"62a55ad8","428":"31368c4d","569":"5daaaa27","638":"9e39ce34","836":"bc0d394a","852":"7e3a0de9","904":"5d6519eb","928":"03926473","943":"bacfc623"}[chunkId] + ".chunk.js";
};